import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import { useState } from 'react'

import PlusIcon from 'public/icons/plus.svg'
import MinusIcon from 'public/icons/minus.svg'
import style from './FaqBox.style'

const FaqBoxStyled = styled.div(props => ({ ...style(props) }))

const FaqBox = ({ question, answer }) => {
    const [isOpen, setOpen] = useState(false)

    return (
        <FaqBoxStyled>
            <div className="question-box">
                <button className="block-control" type="button" onClick={() => setOpen(!isOpen)}>
                    Open/Close FAQ
                </button>

                <div className="question">{question}</div>

                <div className="controls">
                    {!isOpen && <PlusIcon />}
                    {isOpen && <MinusIcon />}
                </div>
            </div>
            {isOpen && (
                <div className="answer-box">
                    <div className="answer">{answer}</div>
                </div>
            )}
        </FaqBoxStyled>
    )
}

FaqBox.propTypes = {
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
}

export default withTranslation('common')(withTheme(FaqBox))
